(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"]) return;
  try {
    
window.addEventListener("load", function () {

  const prefectureItems = [
    { "value": "hokkaido", "label": "北海道" },
    { "value": "aomori",   "label": "青森県" },
    { "value": "iwate",    "label": "岩手県" },
    { "value": "miyagi",   "label": "宮城県" },
    { "value": "akita",    "label": "秋田県" },
    { "value": "yamagata", "label": "山形県" },
    { "value": "fukushima","label": "福島県" },
    { "value": "ibaraki",  "label": "茨城県" },
    { "value": "tochigi",  "label": "栃木県" },
    { "value": "gunma",    "label": "群馬県" },
    { "value": "saitama",  "label": "埼玉県" },
    { "value": "chiba",    "label": "千葉県" },
    { "value": "tokyo",    "label": "東京都" },
    { "value": "kanagawa", "label": "神奈川県" },
    { "value": "niigata",  "label": "新潟県" },
    { "value": "toyama",   "label": "富山県" },
    { "value": "ishikawa", "label": "石川県" },
    { "value": "fukui",    "label": "福井県" },
    { "value": "yamanashi","label": "山梨県" },
    { "value": "nagano",   "label": "長野県" },
    { "value": "gifu",      "label": "岐阜県" },
    { "value": "shizuoka",  "label": "静岡県" },
    { "value": "aichi",     "label": "愛知県" },
    { "value": "mie",       "label": "三重県" },
    { "value": "shiga",     "label": "滋賀県" },
    { "value": "kyoto",     "label": "京都府" },
    { "value": "osaka",     "label": "大阪府" },
    { "value": "hyogo",     "label": "兵庫県" },
    { "value": "nara",      "label": "奈良県" },
    { "value": "wakayama",  "label": "和歌山県" },
    { "value": "tottori",   "label": "鳥取県" },
    { "value": "shimane",   "label": "島根県" },
    { "value": "okayama",   "label": "岡山県" },
    { "value": "hiroshima", "label": "広島県" },
    { "value": "yamaguchi", "label": "山口県" },
    { "value": "tokushima", "label": "徳島県" },
    { "value": "kagawa",    "label": "香川県" },
    { "value": "ehime",     "label": "愛媛県" },
    { "value": "kochi",     "label": "高知県" },
    { "value": "fukuoka",   "label": "福岡県" },
    { "value": "saga",      "label": "佐賀県" },
    { "value": "nagasaki",  "label": "長崎県" },
    { "value": "kumamoto",  "label": "熊本県" },
    { "value": "oita",      "label": "大分県" },
    { "value": "miyazaki",  "label": "宮崎県" },
    { "value": "kagoshima", "label": "鹿児島県" },
    { "value": "okinawa",   "label": "沖縄県" }
  ]

  /* --- DOMの取得 --- */
  const areaElements = document.querySelectorAll(".area-data");
  const storeElements = document.querySelectorAll(".store-data");

  const areaButtonsWrapper = document.getElementById("area-buttons-wrapper");
  const prefecturesWrapper = document.getElementById("prefectures-wrapper");
  const storeListWrapper  = document.getElementById("store-list-wrapper");

  if (areaElements.length === 0) {
    areaButtonsWrapper.innerHTML = "<p>エリアが登録されていません。</p>";
    return;
  }

  /* --- エリアボタン生成 --- */
  areaElements.forEach((areaEl, index) => {

    const areaId = areaEl.dataset.areaId;
    const areaName = areaEl.dataset.areaName;

    const btn = document.createElement("button");
    btn.classList.add("area-button");
    btn.dataset.areaId = areaId;
    btn.textContent = areaName;

    btn.addEventListener("click", () => {
      renderPrefectures(areaId);
      activateAreaButton(btn);
    });

    areaButtonsWrapper.appendChild(btn);
  });

  /* --- ボタンアクティブ制御 --- */
  function activateAreaButton(button) {
    document.querySelectorAll(".area-button").forEach(b => b.classList.remove("active"));
    button.classList.add("active");
  }

  /** --- 都道府県のボタンアクティブ制御 --- */
  function activePrefectureButton(button) {
    document.querySelectorAll(".prefecture-button").forEach(b => b.classList.remove("active"));
    button.classList.add("active");
  }

  /* --- エリアの店舗一覧取得関数 --- */
  function getAreaItems(areaId) {
    return Array.from(storeElements).filter(
      store => store.dataset.areaId === areaId
    );
  }

  /* --- 都道府県の店舗一覧種等関数 --- */
  function getPrefectureItems(items, prefectureId) {
    return Array.from(items).filter(
      item => item.dataset.prefecture === prefectureId
    );
  }


  /* --- 都道府県制御 --- */
  function renderPrefectures(areaId) {
    // 初期化
    prefecturesWrapper.innerHTML = "";

    // エリア名表示
    const targetArea = Array.from(areaElements).find(a => a.dataset.areaId === areaId);
    const areaTitle = document.createElement("h4");
    areaTitle.textContent = targetArea.dataset.areaName;
    areaTitle.classList.add("area-title");
    prefecturesWrapper.appendChild(areaTitle);

    const areaFilteredItems = getAreaItems(areaId);

    // 店舗に設定されている都道府県一覧取得
    const prefectureList = Array.from(
      new Set(
        Array.from(areaFilteredItems)
          .map(el => el.dataset.prefecture)
          .filter(Boolean) // 空データを除外
      )
    );

    // 都道府県が設定されていないエリアであれば全ての店舗を表示
    if(prefectureList.length === 0) {
      renderStores(areaFilteredItems);
      return;
    }

    const prefectureButtonsWrapper = document.createElement("div");
    prefectureButtonsWrapper.classList.add("prefecture-buttons-wrapper");

    const prefectureSelectWrapper = document.createElement("div");
    prefectureSelectWrapper.classList.add("prefecture-select-wrapper");
    // SP画面用セレクト
    const select = document.createElement("select");
    select.id = 'prefecture-select';

    // 都道府県のボタン表示
    prefectureList.forEach((p, index) => {
      const target = prefectureItems.find(pi => pi.value === p);
      const label = target ? target.label : '';

      // PC画面用選択ボタン
      const btn = document.createElement("button");
      btn.classList.add("prefecture-button");

      // SP画面用オプション
      const option = document.createElement('option');
      option.value = p;
      option.textContent = label;

      select.appendChild(option);

      if(index === 0) {
        activePrefectureButton(btn);
      }

      const icon = document.createElement("span");
      icon.classList.add("prefecture-icon");
      btn.appendChild(icon);

      btn.dataset.prefectureId = p;
      btn.appendChild(document.createTextNode(label));

      btn.addEventListener("click", () => {
        renderPrefectureStores(areaId, p);
        activePrefectureButton(btn);
        // セレクトボックスと連動させる
        select.value = p;
      });

      prefectureButtonsWrapper.appendChild(btn);
    });
    // PC画面用のボタン一覧を追加
    prefecturesWrapper.appendChild(prefectureButtonsWrapper);

    // SP画面用のセレクトボックスを追加
    select.addEventListener('change', (event) => {
      renderPrefectureStores(areaId, event.target.value);
      // ボタンと連動
      const btn = document.querySelector(`[data-prefecture-id="${event.target.value}"]`);
      activePrefectureButton(btn);
    });
    prefectureSelectWrapper.appendChild(select);
    prefecturesWrapper.appendChild(prefectureSelectWrapper);

    // 最初の都道府県店舗表示
    renderPrefectureStores(areaId, prefectureList[0]);

  }

  /* --- 都道府県の店舗表示 --- */
  function renderPrefectureStores(areaId, prefectureId) {
    const areaFilteredItems = getAreaItems(areaId);
    const items = Array.from(areaFilteredItems).filter(
      item => item.dataset.prefecture === prefectureId
    );
    renderStores(items);
  }

  /* --- 店舗リスト表示 --- */
  function renderStores(items) {
    storeListWrapper.innerHTML = "";

    if (items.length === 0) {
      storeListWrapper.innerHTML = "<p>店舗がありません。</p>";
      return;
    }

    // 市区町村でグルーピング
    const grouped = {};
    items.forEach(store => {
      const city = store.dataset.city || "未設定エリア";
      if (!grouped[city]) grouped[city] = [];
      grouped[city].push(store);
    });
    // city を五十音順に並べる
    sortedCities = Object.keys(grouped).sort();

    sortedCities.forEach(city => {

      // 市区町村タイトルごとに分けられたアイテムラッパー
      const cityItem = document.createElement("div");
      cityItem.classList.add("city-wrapper");

      // 市区町村タイトル
      const cityTitle = document.createElement("h4");
      const cityText = document.createElement("span");
      cityText.textContent = city;
      cityTitle.appendChild(cityText);
      cityTitle.classList.add("city-title");
      cityItem.appendChild(cityTitle);

      grouped[city].forEach(store => {

        const storeItem = document.createElement("div");
        storeItem.classList.add("store-item");

        /** 店舗名 */
        const basicInfoEl = document.createElement("div");
        basicInfoEl.classList.add("basic-info");

        const nameEl = document.createElement("p");
        nameEl.classList.add("store-title");
        nameEl.textContent = store.dataset.name;
        basicInfoEl.appendChild(nameEl);
        /** 住所（addressタグ使用） */
        const addressWrapperEl = document.createElement("div");
        addressWrapperEl.classList.add("address-wrapper");

        const addressEl = document.createElement("address");
        addressEl.textContent = store.dataset.address;
        addressWrapperEl.appendChild(addressEl);
        /** Google Map リンク */
        if(store.dataset.map) {
          const mapLink = document.createElement("a");
          mapLink.href = store.dataset.map;
          mapLink.target = "_blank";
          mapLink.textContent = "MAP";
          addressWrapperEl.appendChild(mapLink);
        }
        basicInfoEl.appendChild(addressWrapperEl);
        storeItem.appendChild(basicInfoEl);
        /** 電話番号（tel: リンク） */
        if(store.dataset.tel) {
          const telLink = document.createElement("a");
          const telNumber = store.dataset.tel.replace(/-/g, ""); 
          telLink.href = `tel:${telNumber}`;
          telLink.textContent = store.dataset.tel;
          storeItem.appendChild(telLink); 
        }

        cityItem.appendChild(storeItem);
      });

      storeListWrapper.appendChild(cityItem);
    });
  }

  /* --- 初期表示：最初のエリアを表示 --- */
  const firstAreaId = areaElements[0].dataset.areaId;
  renderPrefectures(firstAreaId);
  activateAreaButton(areaButtonsWrapper.querySelector(".area-button"));

});

  } catch(e) { console.error(e); }
})();
})();
